import { render, staticRenderFns } from "./AdminCorporationSwitch.vue?vue&type=template&id=7b72ca76&"
import script from "./AdminCorporationSwitch.vue?vue&type=script&lang=js&"
export * from "./AdminCorporationSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports